import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { Box, Spinner } from "grommet";

const PursuitAccessRoute = () => {
  const { user, authLoading } = useContext(AuthContext);

  if (authLoading) {
    return (
      <Box fill align="center" justify="center">
        <Spinner size="large" />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!["pursuit_access", "master_admin"].includes(user.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default PursuitAccessRoute;
